import { render, staticRenderFns } from "./AlertAutoDismiss.vue?vue&type=template&id=4e535ef4"
import script from "./AlertAutoDismiss.vue?vue&type=script&lang=js"
export * from "./AlertAutoDismiss.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports